import { Routes } from '@angular/router';
import { AuthResponseComponent } from './auth-response/auth-response.component';
import { MainViewComponent } from './main-view/main-view.component';
import { LoginComponent } from './auth/login/login.component';
import { WelcomeComponent } from './welcome/welcome.component';

export const routes: Routes = [
  {
    path: 'auth-response',
    component: AuthResponseComponent,
  },
  {
    path: '',
    component: MainViewComponent,
    children: [
      {
        path: '',
        component: WelcomeComponent,
      },
      {
        path: 'auth/login',
        component: LoginComponent,
      },
      {
        path: 'auth/register',
        loadComponent: () => import('./auth/register/register.component').then((m) => m.RegisterComponent),
      },
      {
        path: 'auth/verify-email',
        loadComponent: () => import('./auth/verify-email/verify-email.component').then((m) => m.VerifyEmailComponent),
      },

      {
        path: 'auth/reset-password-initiate',
        loadComponent: () =>
          import('./auth/reset-password-initiate/reset-password-initiate.component').then(
            (m) => m.ResetPasswordInitiateComponent,
          ),
      },
      {
        path: 'auth/reset-password-set-new',
        loadComponent: () =>
          import('./auth/reset-password-set-new/reset-password-set-new.component').then(
            (m) => m.ResetPasswordSetNewComponent,
          ),
      },
      {
        path: 'public/competitions/calendar/by-year-month/:yearMonth',
        loadComponent: () =>
          import('./competition/competition-calendar/competition-calendar.component').then(
            (m) => m.CompetitionCalendarComponent,
          ),
      },
      {
        path: 'public/competitions/calendar',
        loadComponent: () =>
          import('./competition/competition-calendar/competition-calendar.component').then(
            (m) => m.CompetitionCalendarComponent,
          ),
      },
      {
        path: 'public/competitions/results/:competitionId',
        loadComponent: () =>
          import('./competition/competition-results/competition-results.component').then(
            (m) => m.CompetitionResultsComponent,
          ),
      },
      {
        path: 'public/competitions/results/:competitionId/events/:shootingEventId',
        loadComponent: () =>
          import('./competition/competition-results-event/competition-results-event.component').then(
            (m) => m.CompetitionResultsEventComponent,
          ),
      },
      {
        path: 'competitions/register/:competitionId',
        loadComponent: () =>
          import('./competition/competitions-register/competitions-register/competitions-register.component').then(
            (m) => m.CompetitionsRegisterComponent,
          ),
      },
    ],
  },
  {
    path: 'organizations',

    component: MainViewComponent,
    children: [
      {
        path: '',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./organizations/organizations-list/organizations-list.component').then(
                (m) => m.OrganizationsListComponent,
              ),
          },
          {
            path: 'add',
            loadComponent: () =>
              import('./organizations/organizations-edit/organizations-edit.component').then(
                (m) => m.OrganizationsEditComponent,
              ),
          },
        ],
      },
      {
        path: ':orgId',
        // component: MainViewComponent,
        children: [
          {
            path: 'edit',
            loadComponent: () =>
              import('./organizations/organizations-edit/organizations-edit.component').then(
                (m) => m.OrganizationsEditComponent,
              ),
          },
          {
            path: 'competitions',
            children: [
              {
                path: '',
                loadComponent: () =>
                  import('./competition/competition-list/competition-list.component').then(
                    (m) => m.CompetitionsListComponent,
                  ),
              },
              {
                path: 'add',
                loadComponent: () =>
                  import('./competition/competition-edit/competition-edit.component').then(
                    (m) => m.CompetitionEditComponent,
                  ),
              },
              {
                path: ':competitionId',

                loadComponent: () =>
                  import(
                    './competition/competition-dashboard/competition-dashboard-main-view/competition-dashboard-main-view.component'
                  ).then((m) => m.CompetitionDashboardMainViewComponent),

                children: [
                  {
                    path: 'edit',
                    loadComponent: () =>
                      import('./competition/competition-edit/competition-edit.component').then(
                        (m) => m.CompetitionEditComponent,
                      ),
                  },
                  {
                    path: 'athletes/manage',
                    loadComponent: () =>
                      import('./competition/athletes-list-edit/athletes-list-edit.component').then(
                        (m) => m.AthletesListEditComponent,
                      ),
                  },
                  {
                    path: 'athletes/:competitionAthleteId/edit',
                    loadComponent: () =>
                      import('./competition-athletes/competition-athlete-edit/competition-athlete-edit.component').then(
                        (m) => m.CompetitionAthleteEditComponent,
                      ),
                  },
                  {
                    path: 'relay',
                    loadComponent: () =>
                      import('./relay/relay-browse-and-edit/relay-browse-and-edit.component').then(
                        (m) => m.RelayBrowseAndEditComponent,
                      ),
                  },
                  {
                    path: 'relay/:relayId/results-entry',
                    loadComponent: () =>
                      import('./relay/result-entry-points/result-entry-points.component').then(
                        (m) => m.ResultEntryPointsComponent,
                      ),
                  },
                  {
                    path: 'partial-sums',
                    children: [
                      {
                        path: 'partial-sums-list-and-edit',
                        loadComponent: () =>
                          import('./scoring/partial-sums-list-and-edit/partial-sums-list-and-edit.component').then(
                            (m) => m.PartialSumsListAndEditComponent,
                          ),
                      },
                    ],
                  },
                  {
                    path: 'registration-list',
                    loadComponent: () =>
                      import(
                        './competition/competition-registration/competition-registration-list/competition-registration-list.component'
                      ).then((m) => m.CompetitionRegistrationListComponent),
                  },
                  {
                    path: 'registration-list/:registrationId/edit',
                    loadComponent: () =>
                      import(
                        './competition/competition-registration/competition-registration-edit/competition-registration-edit.component'
                      ).then((m) => m.CompetitionRegistrationEditComponent),
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: 'progress',
    component: MainViewComponent,
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./progress/dashboard/dashboard.component').then((m) => m.DashboardComponent),
      },
      {
        path: 'data-table',
        loadComponent: () => import('./progress/data-table/data-table.component').then((m) => m.DataTableComponent),
      },
      {
        path: 'datapoint/add-datapoint',
        loadComponent: () =>
          import('./progress/datapoint-edit/datapoint-edit.component').then((m) => m.DatapointEditComponent),
      },
      {
        path: 'datapoint/:metricId/:metricCategory/:date/edit',
        loadComponent: () =>
          import('./progress/datapoint-edit/datapoint-edit.component').then((m) => m.DatapointEditComponent),
      },

      {
        path: 'metrics-config',
        loadComponent: () =>
          import('./progress/config-metrics/config-metrics.component').then((m) => m.ConfigMetricsComponent),
      },
    ],
  },
  {
    path: 'settings',
    component: MainViewComponent,
    children: [
      {
        path: 'profile',
        loadComponent: () => import('./settings/profile/profile.component').then((m) => m.ProfileComponent),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/',
  },
];
